import Glide from '@glidejs/glide';

new Glide('.Wines-slider', {
  perView: 3,
  bound: 3,
  type: 'carousel',
  // autoplay: 3000,
  breakpoints: {
    960: {
      perView: 1,
      bound: 1
    }
  }
}).mount();

const navToggle = document.querySelector('.Navbar-toggle');
const navMenu = document.querySelector('.Navbar-menu');
const menuItems = document.querySelectorAll('.Navbar-item')

if (navToggle) {
  navToggle.addEventListener('click', (e) => {
    e.preventDefault();

    navMenu.classList.toggle('isOpen');
  })
}

if (menuItems) {
  menuItems.forEach((item) => {
    item.addEventListener('click', () => {
      navMenu.classList.remove('isOpen');
    });
  });
}
